import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Self-hosted, so the page makes no third-party requests (and the CSP stays `'self'`).
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/400-italic.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "@fontsource/ibm-plex-mono/600.css";
// Signifier isn't a Google font (Klim, commercial); Newsreader stands in until its files are added.
import "@fontsource-variable/newsreader";
import "./index.css";
import App from "./App.tsx";

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
);
